export default function ContactSupport() {

  return (
      <p>پشتیبانی</p>
  );
};